import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import BeatLoading from './Loader/BeatLoader';

export default function ConfirmationDialog({ open, handleClose, func, title = " آیا از حذف این آیتم اطمینان دارید؟", loading = false }) {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {title}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>خیر</Button>
          {
            <Button onClick={func} autoFocus disabled={loading}>
              <BeatLoading loading={loading} color={"#e65100"} size={8} />بله
            </Button>
          }
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}